var map = {
	"./AgeUpIcon1Active_ua.webp": "c20d",
	"./AgeUpIcon2Active_ua.webp": "583a",
	"./AgeUpIcon3Active_ua.webp": "b614",
	"./AgeUpIcon4Active_ua.webp": "1d95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b95";